<template>
  <!--附件下载弹出框-->
  <el-dialog
    :visible.sync="changeHistoryVisible"
    title="改配历史查询"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthChangeHistory1"
  >
    <div>
      <!-- table start -->
      <el-row style="margin-top: 15px;margin-bottom: 20px">
        <hot-table
          ref="changeHistoryTableRef"
          :data-source="changeHistoryTableDataSource"
          :settings="changeHistoryTableSettings"
          col-settings-key="changeHistory"
        >
          <hot-column :has-tip="true" data="oldVesselName" title="旧船名" width="150"></hot-column>
          <hot-column :has-tip="true" data="oldVoyage" title="旧航次" width="150"></hot-column>
          <hot-column :has-tip="true" data="oldEdt" title="旧开航日期" date-format="YYYY-MM-DD "
                      width="150"></hot-column>
          <hot-column :has-tip="true" data="newVesselName" title="新船名" width="150"></hot-column>
          <hot-column :has-tip="true" data="newVoyage" title="新航次" width="150"></hot-column>
          <hot-column :has-tip="true" data="newEdt" title="新开航日期" date-format="YYYY-MM-DD"
                      width="150"></hot-column>
        </hot-table>
        <!-- 分页start -->
        <div class="pg_div">
          <el-pagination
            :current-page="pageConfig.currentPage"
            :layout="pageConfig.layout"
            :page-size="pageConfig.pageSize"
            :page-sizes="pageConfig.pageSizes"
            :total="pageConfig.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
        <!-- 分页end -->
      </el-row>
      <!-- table end -->
    </div>
  </el-dialog>
</template>

<script>

import ebOrder from "@/api/ebOrder";
import { queryMfOrderByTransferStatus } from '@/api/queryMainSystem'
export default {
  name: 'changeHistoryUpBox',
  props: {
    changeHistoryVisibleFlagInit: Boolean,
    ebOrder: Object
  },
  data() {
    return {
      changeHistoryVisible: false,
      // 表格数据
      changeHistoryTableDataSource: [],
      // 表格设置
      changeHistoryTableSettings: {
        height: 170,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
        showSelection: false //把checkBox隐藏
      },
      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
    }
  },
  // 监听
  watch: {
    changeHistoryVisibleFlagInit() {
      let self = this
      self.changeHistoryVisible = true
      this.queryChangeHistory()
    }
  },
  created() {
  },
  mounted() {

    },
    methods: {
      // pageSize 改变时会触发
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        this.pageConfig.pageSize = val
        let self = this
        self.queryChangeHistory()
      },
      // currentPage 改变时会触发
      handleCurrentChange(val) {
        this.pageConfig.currentPage = val
        let self = this
        self.queryChangeHistory()
      },
      //获取表格数据
      queryChangeHistory() {
        let self = this
        console.log("ebOrder", self.ebOrder)
        let params = {
          goOrderId: self.ebOrder.goOrderId,
        }
        if(params.goOrderId === undefined || params.goOrderId === null){
          self.$coreMethods.message("info", "尚未存在改配信息！");
          return
        }
        queryMfOrderByTransferStatus(params).then(res => {
          if(res.success){
            self.changeHistoryTableDataSource = res.records.records[0].records;
            self.pageConfig.totalRecord = res.total;
          }
          /*let changeHistory1 = res.records.filter(ebOrder => {
            return ebOrder.transferStatus === 1
          })
          let changeHistory2 = res.records.filter(ebOrder => {
            return ebOrder.transferStatus === 2
          })
          let changeHistory = {
            vesselNameEn1: changeHistory1.vesselNameEn,
            voyage1: changeHistory1.voyage,
            etd1: changeHistory1.etd,
            vesselNameEn2: changeHistory2.vesselNameEn,
            voyage2: changeHistory2.voyage,
            etd2: changeHistory2.etd,
          }
          self.changeHistoryTableDataSource.push(changeHistory)
          self.pageConfig.totalRecord = changeHistory1.length*/
        })
      },
      //子组件
      clickModule() {

      }
    }
  }
</script>

<style>
  .customWidthChangeHistory1 {
    width: 40%;
    height: 320px;
  }

  .el-dialog__body {
    padding: 0px;
  }

</style>
